(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bundles"] && !Shopify.designMode) return;
  try {
    
  class BundleTabs extends HTMLElement {
    connectedCallback() {
      this.tabs = [...this.querySelectorAll('[role="tab"]')];
      this.panels = [...this.querySelectorAll('[role="tabpanel"]')];
      this.tabList = this.querySelector('[data-tab-list]');
      this.previousButton = this.querySelector('[data-tabs-previous]');
      this.nextButton = this.querySelector('[data-tabs-next]');
      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.selectTab(tab.dataset.tab));
        tab.addEventListener('keydown', (event) => this.handleKeydown(event));
      });
      this.previousButton?.addEventListener('click', () => this.scrollTabsBackward());
      this.nextButton?.addEventListener('click', () => this.scrollTabsForward());
      this.tabList?.addEventListener('scroll', () => this.updateScrollButtons(), { passive: true });
      this.resizeObserver = new ResizeObserver(() => this.updateScrollButtons());
      if (this.tabList) this.resizeObserver.observe(this.tabList);
      requestAnimationFrame(() => this.updateScrollButtons());
      this.querySelectorAll('[data-bundle-form]').forEach((form) => {
        form.addEventListener('submit', (event) => this.addBundle(event));
      });
      if (Shopify.designMode) {
        this.addEventListener('shopify:block:select', (event) => {
          const block = event.target.closest('[data-bundle-block-tab]');
          if (block) this.selectTab(block.dataset.bundleBlockTab);
        });
      }
    }

    disconnectedCallback() {
      this.resizeObserver?.disconnect();
    }

    scrollTabsForward() {
      if (!this.tabList) return;
      this.tabList.scrollBy({ left: Math.max(this.tabList.clientWidth * 0.75, 180), behavior: 'smooth' });
    }

    scrollTabsBackward() {
      if (!this.tabList) return;
      this.tabList.scrollBy({ left: Math.min(this.tabList.clientWidth * -0.75, -180), behavior: 'smooth' });
    }

    updateScrollButtons() {
      if (!this.tabList || !this.previousButton || !this.nextButton) return;
      const hasOverflow = this.tabList.scrollWidth > this.tabList.clientWidth + 2;
      const atStart = this.tabList.scrollLeft <= 2;
      const atEnd = this.tabList.scrollLeft + this.tabList.clientWidth >= this.tabList.scrollWidth - 2;
      this.previousButton.hidden = !hasOverflow || atStart;
      this.nextButton.hidden = !hasOverflow || atEnd;
    }

    selectTab(value) {
      const selectedTab = this.tabs.find((tab) => tab.dataset.tab === value);
      const update = () => {
        this.tabs.forEach((tab) => {
          const active = tab.dataset.tab === value;
          tab.setAttribute('aria-selected', active ? 'true' : 'false');
          tab.tabIndex = active ? 0 : -1;
        });
        this.panels.forEach((panel) => {
          panel.hidden = panel.dataset.panel !== value;
        });
      };
      selectedTab?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
      if (document.startViewTransition && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        document.startViewTransition(update);
      } else {
        update();
      }
    }

    handleKeydown(event) {
      const currentIndex = this.tabs.indexOf(event.currentTarget);
      let nextIndex = currentIndex;
      if (event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % this.tabs.length;
      if (event.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
      if (event.key === 'Home') nextIndex = 0;
      if (event.key === 'End') nextIndex = this.tabs.length - 1;
      if (nextIndex === currentIndex) return;
      event.preventDefault();
      const nextTab = this.tabs[nextIndex];
      this.selectTab(nextTab.dataset.tab);
      nextTab.focus();
    }

    async addBundle(event) {
      event.preventDefault();
      const form = event.currentTarget;
      const button = form.querySelector('button[type="submit"]');
      const label = form.querySelector('[data-button-label]');
      const status = form.querySelector('[data-bundle-status]');
      const originalLabel = label.textContent;
      const formData = new FormData(form);
      const items = [];
      for (let index = 0; formData.has(`items[${index}][id]`); index += 1) {
        items.push({
          id: Number(formData.get(`items[${index}][id]`)),
          quantity: Number(formData.get(`items[${index}][quantity]`)),
        });
      }
      button.disabled = true;
      label.textContent = form.dataset.addingLabel;
      status.textContent = '';
      try {
        const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items }),
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || result.message);
        label.textContent = form.dataset.addedLabel;
        status.textContent = form.dataset.addedStatus;
        window.location.assign(`${window.Shopify.routes.root}cart`);
      } catch (error) {
        label.textContent = originalLabel;
        status.textContent = error.message || form.dataset.errorStatus;
        button.disabled = false;
      }
    }
  }

  if (!customElements.get('bundle-tabs')) customElements.define('bundle-tabs', BundleTabs);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-announcements"] && !Shopify.designMode) return;
  try {
    
  class AnnouncementMarquee extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-marquee-track]');
      this.content = this.querySelector('[data-marquee-content]');
      this.items = this.querySelector('[data-marquee-items]');
      this.resizeObserver = new ResizeObserver(() => this.scheduleLayout());
      this.resizeObserver.observe(this);
      document.fonts?.ready.then(() => this.scheduleLayout());
      this.scheduleLayout();
    }

    disconnectedCallback() {
      this.resizeObserver?.disconnect();
      cancelAnimationFrame(this.layoutFrame);
    }

    scheduleLayout() {
      cancelAnimationFrame(this.layoutFrame);
      this.layoutFrame = requestAnimationFrame(() => this.layout());
    }

    layout() {
      if (!this.track || !this.content || !this.items) return;

      this.track.querySelectorAll('[data-marquee-generated]').forEach((element) => element.remove());

      const itemWidth = this.items.getBoundingClientRect().width;
      if (itemWidth === 0) return;

      const copies = Math.max(1, Math.ceil(this.clientWidth / itemWidth));

      for (let index = 1; index < copies; index += 1) {
        const repeatedItems = this.items.cloneNode(true);
        repeatedItems.dataset.marqueeGenerated = '';
        repeatedItems.setAttribute('aria-hidden', 'true');
        repeatedItems.querySelectorAll('a, button, input, select, textarea').forEach((element) => {
          element.setAttribute('tabindex', '-1');
        });
        this.content.appendChild(repeatedItems);
      }

      const repeatedContent = this.content.cloneNode(true);
      repeatedContent.dataset.marqueeGenerated = '';
      repeatedContent.setAttribute('aria-hidden', 'true');
      repeatedContent.querySelectorAll('a, button, input, select, textarea').forEach((element) => {
        element.setAttribute('tabindex', '-1');
      });
      this.track.appendChild(repeatedContent);

      const speed = Math.max(1, Number(this.dataset.speed) || 50);
      this.style.setProperty('--announcement-marquee-duration', `${this.content.scrollWidth / speed}s`);
    }
  }

  if (!customElements.get('announcement-marquee')) {
    customElements.define('announcement-marquee', AnnouncementMarquee);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["multimodal-review-carousel"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-review-carousel]').forEach((carousel) => {
    if (carousel.dataset.initialized === 'true') return;
    carousel.dataset.initialized = 'true';

    const track = carousel.querySelector('[data-review-track]');
    const previous = carousel.querySelector('[data-review-previous]');
    const next = carousel.querySelector('[data-review-next]');

    const move = (direction) => {
      const card = track.querySelector('[data-review-card]');
      if (!card) return;
      const gap = Number.parseFloat(getComputedStyle(track).gap) || 0;
      track.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: 'smooth' });
    };

    previous?.addEventListener('click', () => move(-1));
    next?.addEventListener('click', () => move(1));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["supplement-diagnostic"] && !Shopify.designMode) return;
  try {
    
  class SupplementDiagnostic extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;
      this.dataset.initialized = 'true';
      this.questions = [...this.querySelectorAll('[data-diagnostic-question]')];
      this.answers = new Array(this.questions.length).fill(null);
      this.currentIndex = 0;
      this.views = new Map(
        [...this.querySelectorAll('[data-diagnostic-view]')].map((view) => [view.dataset.diagnosticView, view])
      );
      this.progressTrack = this.querySelector('[data-progress-track]');
      this.progressValue = this.querySelector('[data-progress-value]');
      this.progressLabel = this.querySelector('[data-progress-label]');
      this.progressPercent = this.querySelector('[data-progress-percent]');
      this.nextButton = this.querySelector('[data-diagnostic-next]');
      this.backButton = this.querySelector('[data-diagnostic-back]');
      this.querySelector('[data-diagnostic-start]')?.addEventListener('click', () => this.start());
      this.nextButton?.addEventListener('click', () => this.next());
      this.backButton?.addEventListener('click', () => this.back());
      this.querySelector('[data-diagnostic-restart]')?.addEventListener('click', () => this.reset());
      this.querySelectorAll('[data-diagnostic-option]').forEach((option) => {
        option.addEventListener('click', () => this.selectOption(option));
      });
      this.addEventListener('shopify:block:select', (event) => this.handleBlockSelect(event));
    }

    showView(name, focus = true) {
      this.views.forEach((view, key) => {
        view.hidden = key !== name;
        view.classList.toggle('is-active', key === name);
      });
      if (focus) requestAnimationFrame(() => this.views.get(name)?.querySelector('[data-view-heading]')?.focus());
    }

    start() {
      if (!this.questions.length) return;
      this.currentIndex = 0;
      this.showView('questions', false);
      this.renderQuestion(true);
    }

    selectOption(option) {
      const question = option.closest('[data-diagnostic-question]');
      if (!question) return;
      const index = Number(question.dataset.questionIndex);
      question
        .querySelectorAll('[data-diagnostic-option]')
        .forEach((item) => item.setAttribute('aria-pressed', String(item === option)));
      this.answers[index] = { primary: option.dataset.primary, secondary: option.dataset.secondary };
      if (this.nextButton) this.nextButton.disabled = false;
    }

    renderQuestion(focus = true) {
      this.questions.forEach((question, index) => {
        question.hidden = index !== this.currentIndex;
      });
      const progress = Math.round(((this.currentIndex + 1) / this.questions.length) * 100);
      if (this.progressValue) this.progressValue.style.width = `${progress}%`;
      if (this.progressTrack) this.progressTrack.setAttribute('aria-valuenow', String(this.currentIndex + 1));
      if (this.progressPercent) this.progressPercent.textContent = `${progress}%`;
      if (this.progressLabel) {
        const prefix = this.progressLabel.dataset.progressPrefix || 'Pregunta';
        const separator = this.progressLabel.dataset.progressSeparator || 'de';
        this.progressLabel.textContent = `${prefix} ${this.currentIndex + 1} ${separator} ${this.questions.length}`;
      }
      if (this.nextButton) this.nextButton.disabled = !this.answers[this.currentIndex];
      if (focus)
        requestAnimationFrame(() =>
          this.questions[this.currentIndex]?.querySelector('[data-question-heading]')?.focus()
        );
    }

    next() {
      if (!this.answers[this.currentIndex]) return;
      if (this.currentIndex < this.questions.length - 1) {
        this.currentIndex += 1;
        this.renderQuestion();
        return;
      }
      this.showView('calculating');
      const delay = Number(this.dataset.calculationDelay) || 900;
      window.setTimeout(
        () => this.showResults(),
        window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : delay
      );
    }

    back() {
      if (this.currentIndex === 0) {
        this.showView('intro');
        return;
      }
      this.currentIndex -= 1;
      this.renderQuestion();
    }

    showResults() {
      const outcomes = ['ashwagandha', 'rhodiola', 'lions_mane', 'cordyceps', 'magnesium', 'shatavari'];
      const scores = new Map(
        outcomes.map((outcome, index) => [outcome, { outcome, score: 0, primaryHits: 0, order: index }])
      );
      this.answers.forEach((answer) => {
        if (!answer) return;
        if (answer.primary && scores.has(answer.primary)) {
          scores.get(answer.primary).score += 2;
          scores.get(answer.primary).primaryHits += 1;
        }
        if (answer.secondary && answer.secondary !== 'none' && scores.has(answer.secondary))
          scores.get(answer.secondary).score += 1;
      });

      const cards = new Map(
        [...this.querySelectorAll('[data-diagnostic-result-card]')].map((card) => [card.dataset.outcome, card])
      );
      cards.forEach((card) => {
        card.hidden = true;
      });
      const ranked = [...scores.values()]
        .filter((result) => result.score > 0 && cards.has(result.outcome))
        .sort((a, b) => b.score - a.score || b.primaryHits - a.primaryHits || a.order - b.order)
        .slice(0, 2);

      const empty = this.querySelector('[data-empty-result]');
      if (empty) empty.hidden = ranked.length > 0;
      ranked.forEach((result, index) => {
        const card = cards.get(result.outcome);
        card.hidden = false;
        const badge = card.querySelector('[data-result-badge]');
        if (badge) badge.textContent = index === 0 ? card.dataset.primaryLabel : card.dataset.alternativeLabel;
      });
      this.showView('results');
    }

    reset() {
      this.answers.fill(null);
      this.currentIndex = 0;
      this.querySelectorAll('[data-diagnostic-option]').forEach((option) =>
        option.setAttribute('aria-pressed', 'false')
      );
      this.querySelectorAll('[data-diagnostic-result-card]').forEach((card) => {
        card.hidden = true;
      });
      this.showView('intro');
    }

    handleBlockSelect(event) {
      const question = event.target.closest?.('[data-diagnostic-question]');
      if (!question) return;
      this.currentIndex = Number(question.dataset.questionIndex);
      this.showView('questions', false);
      this.renderQuestion(false);
    }
  }

  if (!customElements.get('supplement-diagnostic'))
    customElements.define('supplement-diagnostic', SupplementDiagnostic);

  } catch(e) { console.error(e); }
})();
})();
